import Layout from '../../components/Layout';
import HeroImageLg from '../../assets/hero-lg.png';
import HeroImageSm from '../../assets/hero-lg.png';
import SKButton from '../../components/UI/SKButton';
import SwitchToProductionMode from '../../components/SwitchToProdMode';
import { ReactComponent as LinkIcon } from '../../assets/icons/link.svg';
import { StorageService } from '../../service/Storage';
import classes from './styles.module.scss';
import { ReactComponent as PlayIcon } from '../../assets/logo/play-store.svg';
import {
  Box,
  Image,
  Heading,
  Flex,
  Text,
  useMediaQuery,
  toast,
  ButtonGroup,
  Button,
} from '@chakra-ui/react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import CTA from 'components/UI/CTA';
import ToggleRow from 'components/ToggleRow';
import SKCard from 'components/UI/SKCard';
import { SIKKA_FAQS } from 'pages/FaqPage/data/faq';
import { copyToClickBoard } from 'utils';
import { DOWNLOAD_PAGE, FAQS_PAGE } from 'constants/route.const';
import { useState } from 'react';
import CertifiedImage from '../../assets/verified_chillar.png';
import OurPlans from './components/OurPlans';

export default function HomePage() {
  const [lang, setLang] = useState('en'); //en||hi
  const navigate = useNavigate();

  const location = useLocation();
  const [isSmall] = useMediaQuery('(max-width:600px)');
  const [isSmallMobile] = useMediaQuery('(max-width:395px)');
  const [isUltraSmall] = useMediaQuery('(max-width:375px)');
  return (
    <Layout>
      {/* <Flex
        flexDir={['column', 'column', 'row']}
        justifyContent={'center'}
        alignItems={'center'}
        pr={[2, 0]}
        // mt={-20}
        // mb={-24}
      >
        <Box pr={6} w={['100%']} display={['block', null, 'none']}>
          <Image
            src={HeroImageSm}
            alt="Chillar Pro  illustration"
            mt={[4, null, 'unset']}
            height={['45vh', '45vh', null, '50vh']}
            mx={'auto'}
          />
        </Box>

        <Flex
          flexDir={'column'}
          maxW={['100%']}
          pr={[0, 0, 0, 0, 8]}
          textAlign={['left']}
          mt={['20px', '50px']}
        >
          <Box>
          <Heading
            fontSize={['32px', '36px', '44px', '46px', '52px']}
            mb={['10px', '20px']}
          >
            Easiest Way to{' '}
            <Text fontSize={['32px', '36px', '44px', '46px', '52px']} width='fit-content' bg='#FFC968' color='white' p='1rem'> 
              earn unlimited money              
            </Text>{' '}
            with India’s best Earning App
          </Heading>
          <img src={CertifiedImage} />
          </Box>
          <Text
            fontSize={['16px', '16px', '18px', '20px']}
            fontWeight={['400']}
            lineHeight={[6, null, 8]}
            mb={'30px'}
            opacity={0.6}
            color={'#883C1E'}
          >
            Chillar Pro  allows you to earn unlimited money by completing simple and
            easy tasks. Upon Completing a set of simple tasks, you will be
            rewarded.
          </Text>
          <Flex justifyContent={['center', 'flex-start']} px={[4, 0]}>
            <CTA />
          </Flex>
          <div className={classes.AppStats}>
      <div className={classes.box}>
        <div className={classes.title}>10L+</div>
        <div className={classes.subtitle}>Daily Winnings</div>
      </div>
      <div className={classes.box}>
        <div className={classes.title}>40K+</div>
        <div className={classes.subtitle}>Installs</div>
      </div>
    </div>
        </Flex>

        <Box display={['none', null, 'block']}>
          <Image
            src={HeroImageLg}
            alt="Chillar Pro  illustration"
            width={['40vw']}
            maxWidth={['550px']}
          />
        </Box>
      </Flex> */}
      <div className={classes.HomePage}>
        <div className={classes.heroContent}>
          <div className={classes.heading}>
            <Heading
              as="h1"
              fontSize={['32px', '36px', '44px', '46px', '52px']}
            >
              Easiest Way to{' '}
              <Text
                ffontSize={['32px', '36px', '44px', '46px', '52px']}
                color="white"
                width="fit-content"
              >
                <span className={classes.textBg}>
                  <span className={classes.textFg}>earn unlimited money</span>
                </span>
              </Text>
              with India’s best Earning App
            </Heading>
            <img src={CertifiedImage} />
          </div>
          <p className={classes.desc}>
            Chillar Pro allows you to earn unlimited money by completing simple
            and easy tasks. Upon Completing a set of simple tasks, you will be
            rewarded.
          </p>
          <div className={classes.buttonGrp}>
            <SKButton
              onClick={() => {
                window.gtag &&
                  window.gtag('event', 'chillarpro_download', {
                    from: 'HOMEPAGE_CTA',
                  });
                navigate(DOWNLOAD_PAGE);
              }}
              bgGradient="linear(to-r, #FFC968, #FBE6AE)"
              color="black"
              fontWeight="500"
            >
              Download Chillar Pro Now
            </SKButton>
          </div>
          <div className={classes.AppStats}>
            <div className={classes.box}>
              <div className={classes.title}>10L+</div>
              <div className={classes.subtitle}>Daily Winnings</div>
            </div>
            <div className={classes.box}>
              <div className={classes.title}>40K+</div>
              <div className={classes.subtitle}>Installs</div>
            </div>
          </div>
        </div>
        <div className={classes.heroImage}>
          <img src={HeroImageSm} />
        </div>
      </div>
      <OurPlans />

      <Flex
        direction={'column'}
        gap={6}
        alignItems={['flex-start', null, 'center']}
        mt={['3rem']}
      >
        {lang === 'hi' ? (
          <Heading fontSize={'1.5rem'}>अक्सर पूछे जाने वाले प्रश्न</Heading>
        ) : (
          <Heading fontSize={'1.5rem'}>Frequently asked questions</Heading>
        )}
        <div style={{ margin: '1rem 0rem' }}>
          <ButtonGroup variant="solid" spacing="0" size="xs" isAttached>
            <Button
              colorScheme={lang === 'en' ? 'brand' : 'gray'}
              onClick={() => setLang('en')}
            >
              English
            </Button>
            <Button
              colorScheme={lang === 'hi' ? 'brand' : 'gray'}
              onClick={() => setLang('hi')}
            >
              Hindi
            </Button>
          </ButtonGroup>
        </div>
        <div className={classes.FaqList}>
          {SIKKA_FAQS.map(d => (
            <SKCard className={classes.card} id={`${d.key}`} key={d.key}>
              <ToggleRow
                key={d.key}
                header={
                  <div className={classes.rowHeader}>{d[lang].title}</div>
                }
                body={d[lang].desc}
                defaultOpen={`#${d.key}` === location.hash}
              />
            </SKCard>
          ))}
        </div>
      </Flex>
      <SwitchToProductionMode />
    </Layout>
  );
}
